import {XauditModel} from '../xaudit.model';

export class SystemTaskDataModel extends XauditModel { 
  SystemTaskId: string;
  LOCID: number;
  ObjectId: string;
  enumObjectTypeID: string;
  isSystem: boolean;
  enumSystemTaskID: string;
  enumUserTaskTypeID: string;
  ForUserGroupID: string;
  ForUserID: string;
  AssignedToUserID: string;
  enumTaskStatusID: string;
  enumTaskPriorityID: string;
  DueDate: Date;
  Description: string;
  ContentParametersJSON: string;
}
